import api from './api'

export const therapyScheduleService = {
  fetchList(params = {}) {
    const query = new URLSearchParams()
    if (params.activityId) query.append('activityId', params.activityId)
    if (params.therapistId) query.append('therapistId', params.therapistId)
    if (params.startDate) query.append('startDate', params.startDate)
    if (params.endDate) query.append('endDate', params.endDate)
    if (params.status) query.append('status', params.status)
    query.append('page', params.page ?? 0)
    query.append('size', params.size ?? 10)
    return api.get(`/therapy/schedules?${query.toString()}`)
  },
  create(payload) {
    return api.post('/therapy/schedules', payload)
  },
  batchCreate(payload) {
    return api.post('/therapy/schedules/batch', payload)
  },
  batchDelete(payload) {
    return api.post('/therapy/schedules/batch-delete', payload)
  },
  remove(id) {
    return api.delete(`/therapy/schedules/${id}`)
  },
  fetchChangeRequests(params = {}) {
    const query = new URLSearchParams()
    if (params.status) query.append('status', params.status)
    const qs = query.toString()
    return api.get(`/therapy/schedules/change-requests${qs ? `?${qs}` : ''}`)
  },
  approveChangeRequest(id) {
    return api.patch(`/therapy/schedules/change-requests/${id}/approve`)
  },
  rejectChangeRequest(id, reason) {
    return api.patch(`/therapy/schedules/change-requests/${id}/reject`, null, { params: { reason } })
  }
}
